import {
  ClientProduct,
  ClientProducts,
  ClientSubcategory,
} from "../types/products";
import {
  ApiProduct,
  ApiProducts,
  ApiSubcategory,
} from "../types/products/api-types";

export const productsAdapter = {
  toClientProducts(apiProducts: ApiProducts[]): ClientProducts[] {
    return apiProducts.map((apiItem) => {
      const baseFields = {
        id: apiItem.id,
        categoryName: apiItem.category_name,
      };

      if ("products" in apiItem) {
        return {
          ...baseFields,
          products: apiItem.products.map(mapProduct),
        };
      } else {
        return {
          ...baseFields,
          subcategories: apiItem.subcategories.map(mapSubcategory),
        };
      }
    });
  },
};

const mapProduct = (apiProduct: ApiProduct): ClientProduct => ({
  id: apiProduct.id,
  name: apiProduct.name,
  price: apiProduct.price,
  description: apiProduct.description,
  imageUrl: apiProduct.image_url,
  weight: apiProduct.weight,
});

const mapSubcategory = (apiSubcategory: ApiSubcategory): ClientSubcategory => ({
  id: apiSubcategory.id,
  categoryName: apiSubcategory.category_name,
  products: apiSubcategory.products.map(mapProduct),
});
